/* eslint-disable react/jsx-props-no-spreading */
import { React } from 'react';

export default function LoginButton(props) {
  return (
    <button
      {...props}
      id="btnLoginSSO"
      type={props.type || 'button'}
      className={`bg-[#3B81F6] text-white w-full h-10 py-2 px-4 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 ${props.className || ''}`}
    >
      {props.children}
    </button>
  );
}
